export const HORIZONTAL_GLOBAL_NAV_HEIGHT = 56;
export const PRODUCT_HOME_BREAKPOINT = 1280;
export const CREATE_BREAKPOINT = 1130;

export const varSearchFocusBorderColor = '--ds--ans--fbc';
export const varSearchHoverBackgroundColor = '--ds--ans--hbgc';
export const varSearchBackgroundColor = '--ds--ans--bgc';
export const varSearchColor = '--ds--ans--c';
export const varSearchBorderColor = '--ds--ans--bc';
